import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '@/store/firebase.store';
import sidebar from '@/store/sidebar.store';
import question from '@/store/question.store';
import quiz from '@/store/quiz.store';
import user from '@/store/user.store';
import campaign from '@/store/campaign.store';
import result from '@/store/result.store';
import order from '@/store/order.store';
import product from '@/store/product.store';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {firebase, sidebar, question, quiz, user, campaign, result, order, product}
})